import { useQuery } from '@tanstack/react-query';

import { DetalhamentoImportacaoValidacao } from '../types';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';

export function useQueryDetalhamentoImportacaoValidacao({
    idDetalhamentoCreditoDebitoImportacao,
    enabled,
}: {
    idDetalhamentoCreditoDebitoImportacao: number;
    enabled: boolean;
}) {
    const requestListagem = useRequestListagem();
    const { limit, page } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/financeiro/detalhamentocreditodebitoimportacaovalidacao',
        page,
        limit,
        sort: [{ property: 'dhInclusao', direction: 'DESC' }],
        filter: [
            {
                value: idDetalhamentoCreditoDebitoImportacao,
                operator: 'eq',
                logicalOperator: 'AND',
                property: 'idDetalhamentoCreditoDebitoImportacao',
            },
        ],
    };

    return useQuery<RequestListagem<DetalhamentoImportacaoValidacao[]>>(
        ['queryDetalhamentoErro', requestOptions],
        () => requestListagem(requestOptions).then((res) => res.data),
        {
            enabled,
        },
    );
}
